<template>
  <section class="painel-search-filter">
    <div class="painel-search-filter__row">
      <div
        class="painel-search-filter__group"
        :class="{ 'painel-search-filter__group--full': !isAdmin }"
      >
        <label class="painel-search-filter__label" :for="searchInputId">Pesquise por</label>
        <div class="painel-search-filter__field">
          <svg class="painel-search-filter__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" stroke-width="2"/>
            <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <input
            :id="searchInputId"
            :value="search"
            type="text"
            class="painel-search-filter__input"
            :placeholder="placeholder"
            @input="$emit('update:search', $event.target.value)"
            @keyup.enter="$emit('search')"
          />
        </div>
      </div>

      <div v-if="isAdmin" class="painel-search-filter__group">
        <label class="painel-search-filter__label" :for="clienteSelectId">Busque por Cliente</label>
        <div class="painel-search-filter__field">
          <svg class="painel-search-filter__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" stroke-width="2"/>
            <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <select
            :id="clienteSelectId"
            :value="selectedClienteId"
            class="painel-search-filter__select"
            :class="{ 'painel-search-filter__select--placeholder': !selectedClienteId }"
            @change="onClienteChange"
          >
            <option value="">Buscar...</option>
            <option
              v-for="cliente in clientes"
              :key="cliente.id"
              :value="String(cliente.id)"
            >
              {{ cliente.nome }} ({{ cliente.codigo }})
            </option>
          </select>
        </div>
      </div>

      <button
        v-if="$listeners.refresh"
        type="button"
        class="painel-search-filter__refresh"
        :disabled="refreshing"
        :aria-busy="refreshing ? 'true' : 'false'"
        @click="$emit('refresh')"
      >
        <IconRefresh
          class="painel-search-filter__refresh-icon"
          :class="{ 'painel-search-filter__refresh-icon--spinning': refreshing }"
        />
        <span>{{ refreshing ? 'Atualizando...' : 'Atualizar' }}</span>
      </button>
    </div>
  </section>
</template>

<script>
import IconRefresh from '@/assets/icons/IconRefresh.vue';

export default {
  name: 'PainelSearchFilter',

  components: {
    IconRefresh
  },

  props: {
    name: {
      type: String,
      required: true
    },
    search: {
      type: String,
      default: ''
    },
    selectedClienteId: {
      type: String,
      default: ''
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    clientes: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Buscar...'
    },
    refreshing: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    searchInputId() {
      return `${this.name}-search`;
    },

    clienteSelectId() {
      return `${this.name}-cliente`;
    }
  },

  methods: {
    onClienteChange(event) {
      this.$emit('update:selectedClienteId', event.target.value);
      this.$emit('cliente-change');
    }
  }
};
</script>

<style scoped>
.painel-search-filter {
  padding: 1.25rem 1.5rem 1rem;
}

.painel-search-filter__row {
  display: flex;
  align-items: flex-end;
  gap: 1.5rem;
}

.painel-search-filter__group {
  flex: 1;
  min-width: 0;
}

.painel-search-filter__group--full {
  flex: 1 1 100%;
}

.painel-search-filter__label {
  display: block;
  margin-bottom: 0.5rem;
  color: #005b61;
  font-size: 0.9375rem;
  font-weight: 700;
}

.painel-search-filter__field {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 1.25rem;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: #fff;
}

.painel-search-filter__icon {
  flex-shrink: 0;
  color: #9ca3af;
}

.painel-search-filter__input,
.painel-search-filter__select {
  width: 100%;
  min-width: 0;
  border: none;
  outline: none;
  color: #111827;
  font-size: 0.9375rem;
  background: transparent;
}

.painel-search-filter__input::placeholder {
  color: #9ca3af;
}

.painel-search-filter__select {
  padding: 0;
  cursor: pointer;
  appearance: none;
}

.painel-search-filter__select--placeholder {
  color: #9ca3af;
}

.painel-search-filter__field:focus-within {
  border-color: #005b61;
}

.painel-search-filter__refresh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-shrink: 0;
  padding: 0.625rem 1.25rem;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: #fff;
  color: #005b61;
  font-size: 0.9375rem;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.painel-search-filter__refresh:hover:not(:disabled),
.painel-search-filter__refresh:focus-visible {
  border-color: #005b61;
  background: #f0f8f8;
  outline: none;
}

.painel-search-filter__refresh:disabled {
  cursor: default;
  opacity: 0.7;
}

.painel-search-filter__refresh-icon--spinning {
  animation: painel-search-filter-spin 0.9s linear infinite;
}

@keyframes painel-search-filter-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .painel-search-filter__row {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
}
</style>
